import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Search, PlusCircle, Heart, User } from 'lucide-react';

const BottomNav = ({ onAddClick }) => {
    const location = useLocation();

    const navItems = [
        {
            icon: Home,
            label: 'Home',
            path: '/',
            active: location.pathname === '/'
        },
        {
            icon: Search,
            label: 'Search',
            path: '/search',
            active: location.pathname === '/search'
        },
        {
            icon: PlusCircle,
            label: 'Add',
            onClick: onAddClick,
            highlight: true
        },
        {
            icon: Heart,
            label: 'Saved',
            path: '/favourites',
            active: location.pathname === '/favourites'
        },
        {
            icon: User,
            label: 'Profile',
            path: '/profile',
            active: location.pathname === '/profile'
        }
    ];

    return (
        <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 z-40 safe-area-bottom">
            <div className="grid grid-cols-5 h-16">
                {navItems.map((item, index) => {
                    const Icon = item.icon;
                    const isActive = item.active;

                    if (item.onClick) {
                        return (
                            <button
                                key={index}
                                onClick={item.onClick}
                                className={`flex flex-col items-center justify-center gap-1 transition-colors ${item.highlight
                                        ? 'text-primary-600 dark:text-primary-400'
                                        : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100'
                                    }`}
                            >
                                <Icon className={`h-6 w-6 ${item.highlight ? 'scale-110' : ''}`} />
                                <span className="text-xs font-medium">{item.label}</span>
                            </button>
                        );
                    }

                    return (
                        <Link
                            key={index}
                            to={item.path}
                            className={`flex flex-col items-center justify-center gap-1 transition-colors ${isActive
                                    ? 'text-primary-600 dark:text-primary-400'
                                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100'
                                }`}
                        >
                            <Icon className="h-6 w-6" />
                            <span className="text-xs font-medium">{item.label}</span>
                            {isActive && (
                                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-12 h-1 bg-primary-600 dark:bg-primary-400 rounded-t-full" />
                            )}
                        </Link>
                    );
                })}
            </div>
        </nav>
    );
};

export default BottomNav;
